import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

import { loadData, loadOverallData } from '../utils';
import { is768Query } from '~/core/scripts/mediaquery-helper';

async function init(state) {
  const { geojson, topojson } = await loadData(state);
  const overallData = await loadOverallData();

  return {
    data: geojson,
    overallData,
    topojson
  };
}

function setTooltipPos(state, tooltipPos) {
  return { tooltipPos };
}

function setTooltipData(state, tooltipData) {
  return { tooltipData };
}

function setDetailData(state, detailData, detailPos) {
  return { detailData, detailPos };
}

function setDetailPos(state, detailPos) {
  return { detailPos };
}

function setParty(state, selectedParty) {
  return {
    selectedParty: state.selectedParty === selectedParty ? false : selectedParty,
    selectedAnalysis: {}
  };
}

function setAnalysis(state, selectedAnalysis) {
  const nextAnalysis = state.selectedAnalysis.name === selectedAnalysis.name ? {} : selectedAnalysis;
  return {
    selectedAnalysis: nextAnalysis,
    analysisOverlayIsOpen: false,
    selectedParty: nextAnalysis.map ? nextAnalysis.map : null
  };
}

function toggleAnalysisOverlay(state, analysisOverlayIsOpen) {
  return {
    analysisOverlayIsOpen
  };
}

async function toggleAnalysisMode(state, selectedAnalysis) {
  let { data, topojson } = state;

  if (state.hasDataAnalysis) {
    const { geojson, topojson: newTopo } = await loadData({ ...state, isAnalysisMode: !state.isAnalysisMode });
    data = geojson;
    topojson = newTopo;
  }

  if (baseconfig.app.titleAnalysis) {
    let nextTitle = baseconfig.app.title;
    let nextSubtitle = baseconfig.app.subtitle;

    if (!state.isAnalysisMode) {
      nextTitle = baseconfig.app.titleAnalysis;
      nextSubtitle = baseconfig.app.subtitleAnalysis;
    }

    document.querySelector('.topheader-headline > h1').innerHTML = nextTitle;
    document.querySelector('.topheader-headline > h2').innerHTML = nextSubtitle;
  }
  const nextState = {
    isAnalysisMode: !state.isAnalysisMode,
    selectedParty: null,
    data,
    topojson
  };

  if (state.isAnalysisMode) {
    nextState.selectedAnalysis = {};
    nextState.analysisOverlayIsOpen = false;
  }

  if (selectedAnalysis) {
    nextState.selectedParty = selectedAnalysis.map ? selectedAnalysis.map : null;
    nextState.selectedAnalysis = selectedAnalysis;
  }

  return nextState;
}

function getMatchingFeat(state, latlng) {
  if (!state.data || !state.data.features) {
    return null;
  }

  let matchingFeature = null;

  for (let i = 0; i < state.data.features.length; i++) {
    const currFeat = state.data.features[i];
    const isInside = currFeat.type && currFeat.geometry && booleanPointInPolygon([latlng[1], latlng[0]], currFeat);
    if (isInside) {
      matchingFeature = currFeat;
      break;
    }
  }

  return matchingFeature;
}

function geocode(state, res) {
  const latlng = res.response.view[0].result[0].location.displayPosition;
  const nextState = {
    geocoderLatLng: [latlng.latitude + Math.random() / 10000, latlng.longitude + Math.random() / 10000],
    geocodeOutOfRange: false
  };

  const matchingFeature = getMatchingFeat(state, nextState.geocoderLatLng);

  if (!matchingFeature) {
    return {
      geocodeOutOfRange: true
    };
  }

  if (!is768Query()) {
    // for mobile devices we want to show the tooltip

    if (matchingFeature) {
      nextState.detailData = matchingFeature.properties;
    }
  }

  return nextState;
}

function setGeocodePos(state, geocoderLatLng) {
  const nextState = {
    geocoderLatLng,
    geocodeOutOfRange: false
  };

  const matchingFeature = getMatchingFeat(state, geocoderLatLng);

  if (!matchingFeature) {
    return {
      geocodeOutOfRange: true
    };
  }

  if (!is768Query()) {
    // for mobile devices we want to show the tooltip
    if (matchingFeature) {
      nextState.detailData = matchingFeature.properties;
    }
  }

  return nextState;
}

function setGeocodeOutOfRange(state, geocodeOutOfRange) {
  return {
    geocodeOutOfRange
  };
}

export default Store => ({
  init,
  setTooltipPos,
  setTooltipData,
  setDetailData,
  setDetailPos,
  setParty,
  setAnalysis,
  toggleAnalysisOverlay,
  toggleAnalysisMode,
  geocode,
  setGeocodePos,
  setGeocodeOutOfRange
});
